import env, { AppEnv } from '@utils/env';

/**
 * First day the report can show (F003 RN08): November 2026 is the first billed
 * month of the AI-conversation model, so earlier dates are disabled in the
 * picker. Outside production an earlier day keeps older data reviewable.
 */
export const AI_CONVERSATIONS_FIRST_DAY = (
  ['production', 'beta'] as AppEnv[]
).includes(env.APP_ENV)
  ? '2026-11-01'
  : '2026-01-01';

export const ISO_DAY_FORMAT = 'YYYY-MM-DD';
export const ISO_MONTH_FORMAT = 'YYYY-MM';

/** Longest range, in calendar months, the charts can show by day (RN02) */
export const MAX_DAY_VIEW_MONTHS = 2;

/**
 * Width of the month field per app language: the widest range of its month
 * names in Poppins 14 px plus the padding and the calendar icon (56 px).
 * Languages the picker has no names for (e.g. ca) use the English ones.
 */
export const DATE_FIELD_WIDTHS: Record<string, number> = {
  en: 212, // "May 2026 – May 2026"
  es: 212,
  fr: 228, // "Janv. 2026 – Janv. 2026"
  ar: 256, // "أغسطس 2026 – أغسطس 2026"
};

/** Value of the "Todos los agentes IA" option: it stands for no agent filter */
export const ALL_ASSISTANTS_VALUE = '__all__';

/** `nameFile` of the Excel export (the dispatcher's default too) */
export const AI_CONVERSATIONS_EXPORT_FILE_NAME = 'conversaciones-ia';

/** `locate` of the export: its email always goes out in Spanish */
export const AI_CONVERSATIONS_EXPORT_LOCALE = 'es';
